<template>
<main class="profile">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('subscription.detail_title') }}</h1>

    <!-- Container -->
    <section class="container">

      <!-- 契約情報 -->
      <div class="row subscribe-box">
        <div class="form-group subscribe plan">

          <template v-for="(plankey, plantype) in planOptions">
          <div class="price-list" :key="plankey">
            <div class="plan-box" v-if="plantype=='month'" :class="{ 'selected' : selectedPlanType == 'month', 'disabled': (subscription && subscription.gracePeriod && selectedPlanType!='month') }" @click.prevent="selectPlan(plankey)">
              <div class="plan-name-box">
                <div class="plan-status select"></div>
                <div class="plan-name">Monthly plan</div>
              </div>
              <div class="plan-price">
                  <span>¥</span>3,500
              </div>
            </div>
            <div class="plan-box" v-if="plantype=='sixmonth'" :class="{ 'selected' : selectedPlanType == 'sixmonth', 'disabled': (subscription && subscription.gracePeriod && selectedPlanType!='sixmonth') }" @click.prevent="selectPlan(plankey)">
              <div class="plan-name-box">
                <div class="plan-status select"></div>
                <div class="plan-name">6 Months plan</div>
                <div class="plan-name-info">Save 5%</div>
              </div>
              <div class="plan-price">
                  <span>¥</span>19,950
              </div>
            </div>
            <div class="plan-box" v-if="plantype=='year'" :class="{ 'selected' : selectedPlanType == 'year', 'disabled': (subscription && subscription.gracePeriod && selectedPlanType!='year') }" @click.prevent="selectPlan(plankey)">
              <div class="plan-name-box">
                <div class="plan-status select"></div>
                <div class="plan-name">Yearly plan</div>
                <div class="plan-name-info">Save 10%</div>
              </div>
              <div class="plan-price">
                  <span>¥</span>3,7800
              </div>
            </div>
          </div>
          </template>

          <div class="price-list" v-if="!cancelStatus">
            <div class="plan-box" :class="{ 'selected' : selectedPlanType == 'cancel', 'disabled': (subscription && subscription.gracePeriod && selectedPlanType!='cancel') }" @click.prevent="selectPlan('cancel')">
              <div class="plan-name-box">
                <div class="plan-status select"></div>
                <div class="plan-name">{{ $t('subscription.cancel') }}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="form-group">
          <template v-if="!cancelStatus">
            <button class="button button-primary checkmark" @click.prevent="executeChangeSubscription">
              <span v-show="loading">{{ $t('common.button.change') }}></span>
              <span v-show="!loading">{{ $t('common.button.change') }}</span>
            </button>
          </template>
          <template v-else>
            <template v-if="subscription && subscription.gracePeriod">
            <button class="button button-primary checkmark" @click.prevent="resumeSubscription">
              <span v-show="loading">{{ $t('common.button.resume') }}></span>
              <span v-show="!loading">{{ $t('common.button.resume') }}</span>
            </button>
            </template>
            <template v-else>
              <div class="alert">Canceled</div>
            </template>
          </template>
        </div>
      </div>

    </section>
    <!-- /Container -->

</main>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api} from "../../config";
  export default {
    data() {
      return {
        loading: false,
        cancelStatus: null,
        subscribed: false,
        subscription: {},
        subscription_plan: '',
        subscription_status: 'none',
        plan: '',
        planOptions: {},
        planCancel: false
      };
    },
    created () {
      this.planOptions = window.config.stripe.plans
      this.planCancel = false
    },
    async mounted() {
      this.clearSubscription();

      const authUser = this.$store.getters.getAuthUser;

      this.subscribed = authUser.subscribed;

      if(authUser && authUser.subscribed) {
        /*
          "subscription": {
              "trial": false,
              "recurring": true,
              "cancelled": false,
              "gracePeriod": false,
              "ended": false,
              "plan_month": true,
              "plan_sixmonth": false,
              "plan_year": false,
              "period_end":
          },
        */
        // planや状態をセット
        if(authUser.subscription !== undefined) {

          this.subscription = authUser.subscription
          // plan
          if(this.subscription.plan_month) {
            this.subscription_plan = 'Monthly';
            this.plan = this.planOptions['month'];
          } else if(this.subscription.plan_sixmonth) {
            this.subscription_plan = '6 Months';
            this.plan = this.planOptions['sixmonth'];
          } else if(this.subscription.plan_year) {
            this.subscription_plan = 'Yearly';
            this.plan = this.planOptions['year'];
          }

          if(this.subscription.ended || this.subscription.cancelled || this.subscription.gracePeriod) {
            this.cancelStatus = true;
            this.subscription_status = 'Invalid';
            if(this.subscription.gracePeriod) {
              this.subscription_status = 'Withdraw';
            }
          } else {
          
            // trial中か利用中(recurring)
            if(this.subscription.trial || this.subscription.recurring) {
              this.cancelStatus = false;

              if(this.subscription.trial) {
                this.subscription_status = 'Trial';
              } else {
                this.subscription_status = 'Active';
              }
            }
          }
        } else {
          this.cancelStatus = true;
        }
      } else {
        this.cancelStatus = true;
      }
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      selectedPlanType() {

        if(!this.planOptions) return null

        let thisPlanType = null;

        if(this.planOptions['month'] == this.plan) {
          thisPlanType = 'month'
        } else if(this.planOptions['sixmonth'] == this.plan) {
          thisPlanType = 'sixmonth'
        } else if(this.planOptions['year'] == this.plan) {
          thisPlanType = 'year'
        } else {
          thisPlanType = 'cancel'
        }
        return thisPlanType;
      }
    },
    methods: {
      executeChangeSubscription() {
        const self = this;
        if(this.planCancel) {
          this.$store.dispatch('showLoading', true);
          const url = '/subscription/cancel';
          axios.post(url)
              .then(() => {
                axios.get(api.currentUser)
                .then((resp) => {
                    this.cancelStatus = true;

                    if(!self.subscription.trial) {
                      self.$store.dispatch('setAuthUser', resp.data)
                      self.$store.dispatch('showLoading', false)
                      self.$router.push({ name: 'profile'})
                    
                    } else {
                    
                      self.$store.dispatch('showLoading', true)
                      //TODO: 消えてくれない
                      axios.post(api.logout).then(() => {
                        self.$store.dispatch('unsetAuthUser')
                        self.$store.dispatch('unsetProfile')
                        self.$store.dispatch('unsetLanguage')
                        self.$store.dispatch('unsetLessons')
                        self.$store.dispatch('unsetLessonData')
                        self.$store.dispatch('unsetLessonContent')
                        .then(() => {
                          
                          self.$store.dispatch('showLoading', false);
                          self.$router.push({name: 'login'});
                        });
                      });
                    }
                });
              });
        } else {
            if(this.plan && this.plan.length) {
            this.$store.dispatch('showLoading', true)

            const url = '/subscription/change_plan';
            const params = {
                    plan: this.plan
            };
            axios.post(url, params)
                .then(response => {
                if(response.data.status && response.data.status != 'unsubscribed') {
                        axios.get(api.currentUser)
                        .then((resp) => {
                                self.$store.dispatch('setAuthUser', resp.data)
                                self.$store.dispatch('showLoading', false)
                                self.$router.push({ name: 'profile'})
                        });
                } else {
                        this.$store.dispatch('showLoading', false)
                }
                })
                .catch(err => {
                const errResponse = err.response
                console.log(errResponse)
                this.$store.dispatch('showLoading', false)
                });
            }
        }

      },
      resumeSubscription() {
        const self = this;
        if(this.subscription && this.subscription.gracePeriod) {
          self.$store.dispatch('showLoading', true);
          const url = '/subscription/resume';
          axios.post(url)
              .then(() => {
                axios.get(api.currentUser)
                .then((resp) => {
                    self.cancelStatus = true;
                    self.$store.dispatch('setAuthUser', resp.data)
                    self.$store.dispatch('showLoading', false)
                    self.$router.push({ name: 'profile'})
                });
              });
        }
      },
      clearSubscription() {
        this.subscription = {
          trial: false,
          recurring: false,
          cancelled: false,
          gracePeriod: false,
          ended: false,
          plan_month: false,
          plan_sixmonth: false,
          plan_year: false,
          period_end: ''
        };
      },
      selectPlan(playKey) {
        if(this.subscription && this.subscription.gracePeriod) {
            return false;
        }
        if(playKey == 'cancel') {
          this.plan = '';
          this.planCancel = true;
        } else {
          this.plan = playKey;
          this.planCancel = false;
        }
      },
      back() {
        this.$router.push({name: 'profile'})
      }
    }
  }
</script>
